<template>
  <div class='search'>
    <rightNav/>
    <lateralNavigation2 />
    <div class='banxin'>
      <div class='head'>
        <div class='all'>全部结果</div>
        <div class='arrow'></div>
        <div class='keyword'>{{keyword}}</div>
        <div class='arrow'></div>
      </div>
      <div class='result'>
        <div class='sort'>
          <div>排序：</div>
          <div class='default' :class="index=='1'?'active':''" @click="defaultSort()">默认</div>
          <div class='price' :class="index=='2'?'active':''" @click="priceSort()">
            价格
            <div class='arr'>
              <div class='up' :class="type==1?'low':''"></div>
              <div class='down' :class="type==2?'high':''"></div>
            </div>
          </div>
          <div class='sales' :class="index=='3'?'active':''" @click="salesSort()">
            销量
              <img v-show="index!=='3'" src='../../../static/image/reduce@2x.png' alt='' />
              <img v-show="index=='3' && volume==1" src='../../../static/image/reduce2@2x.png' alt='' />
              <img v-show="index=='3' && volume==2" src='../../../static/image/reduce1@2x.png' alt='' />
          </div>
          <div class="priceBox" v-if="searchVal=='宝贝'">
            <div class='min'>¥<input type='number' v-model="minMoney" /></div>
            <div style='margin: 0 8px'>-</div>
            <div class='max'>¥<input type='number' v-model="maxMoney" /></div>
            <div class='btn' @click="priceSearch">确定</div>
            <div class='clear' @click="clearMoney">清空</div>
          </div>
        </div>
        <ProductList :productList='productList' v-if="searchVal=='宝贝' && productList.length>0"></ProductList>
        <div class="empty" v-if="productList.length <= 0">
          <img src="../../../static/image/nosearch@2x.png" alt="">
          <p class="fs20 font-color-999">搜索不到你要找的宝贝呢换个词试试吧～</p>
        </div>
        <div class="network" v-if="searchVal=='宝贝' && noProduct==true && network==true">
          <img src="../../../static/image/poornetwork@2x.png" alt="">
          <p class="fs20 font-color-999">哎呀，网络开小差了～</p>
        </div>
        <div class='store' v-if="searchVal=='店铺'">
          <div class='storeBox' v-for="(item,index) in storeList" :key="index">
            <div class='top'>
              <img
                class='storeImg'
                :src='item.shopLogo'
                alt=''
              />
              <div class='storeDesc'>
                <p class='storeName'>{{item.shopName}}</p>
                <p class='storeSite'>所在地：{{item.shopAdress}}</p>
              </div>
              <div class='enter' @click="toStore(item.shopId)">进入店铺>></div>
            </div>
            <div class='content'>
              <div class='productBox' v-for="(items,indexs) in item.skus" :key="indexs" @click="toProductDetail(items)">
                <img :src='items.image' alt='' />
                <p class='productName'>{{items.productName}}</p>
                <p class='price'>¥{{items.price}}</p>
              </div>
            </div>
          </div>
        </div>
        <el-pagination v-if="productList.length>0 || storeList.length>0" :current-page="page" :page-size="12" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import ProductList from '../../components/base/productList'
import { mapGetters, mapMutations } from 'vuex'
import rightNav from '../../components/canvasShow/rightNav';
import lateralNavigation2 from '../../components/base/lateralNavigation2';
export default {
  mixins: [listSearchMixin],
  components: {
   lateralNavigation2,
    rightNav,
    ProductList
  },
  data () {
    return {
      flag: true,
      page: 1,
      keyword: '',
      searchVal: '',
      index: '1',
      maxMoney: '',
      minMoney: '',
      type: '',
      volume: '',
      productList: [],
      total: 0,
      network: false,
      noProduct: false,
      storeList: [],
      priceOrder:"",
      salesOrder:""
    }
  },
  mounted () {
    this.searchInfo(false)
  },
  computed: {
    ...mapGetters([
      'searchObj'
    ])
  },
  methods: {
    searchInfo (flag) {
      if (this.searchObj.keyword !== undefined) {
        if(flag){
          this.keyword = this.searchObj.keyword
        }else{
          this.keyword = this.$route.query.keyword
        }
        console.log("1111111111111",this.keyword);
        this.searchVal = this.searchObj.searchVal
        this.maxMoney = ''
        this.minMoney = ''
       this.getSearchProducts()
      }
        console.log("this.$route.params ",this.$route.params,);
    },
    ...mapMutations({
      setCurrentPro: 'SET_CURRENTPRO'
    }),
    // 跳转商品详情
    toProductDetail (item) {
      this.setCurrentPro(item)
      this.$router.push({path: '/productDetail'})
    },
    // 获取搜索商品数据
    getSearchProducts () {
      let self = this
      let keyword= this.$route.query.keyword
      let params = {
          url: api.getSearchProducts + `?keyword=`+this.keyword+`&type=${self.type}&maxMoney=${self.maxMoney}&minMoney=${self.minMoney}&volume=${self.volume}&page=${self.page}&pageSize=12`,
          method: 'GET',
          payload:{
              priceOrder:this.priceOrder,
              salesOrder:this.salesOrder,
          }
        }
        self.sendReq(params, (res) => {
          if (res.success) {
            self.productList = res.data.content
            self.total = res.data.totalElements
			console.log(res)
            if (self.total < 1) {
              self.noProduct = true
            }
          } else {
            self.$message({
                message: res.message,
                type: 'warning'
            })
            self.network = true
          }
        })
    },
    // 获取搜索店铺数据
    getShops () {
      let self = this
      let params = {
          url: api.getShops + `?search=${self.keyword}&type=${self.type}&volume=${self.volume}&page=${self.page}&pageSize=12`,
          method: 'GET',
          data: {
          }
        }
        self.sendReq(params, (res) => {
          if (res.success) {
            self.storeList = res.data.list
            self.total = res.data.total
          } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
              self.network = false
            }
        })
    },
    // 跳转到店铺
    toStore (id) {
      this.$router.push({
        path: '/store', query: {shopId: id}
      })
    },
    // 价格搜索
    priceSearch () {
      this.page = 1
      this.getSearchProducts()
    },
    handleCurrentChange (val) {
      this.page = val
      if (this.searchVal === '宝贝') {
        this.getSearchProducts()
      } else {
        this.getShops()
      }
    },
    // 清空价格搜索
    clearMoney () {
      this.minMoney = ''
      this.maxMoney = ''
    },
    // 默认排序
    defaultSort () {
      // this.type = ''
      this.volume = ''
      this.index = '1'
      // this.page = 1
      this.maxMoney = ''
      this.minMoney = ''
      if (this.searchVal === '宝贝') {
        this.getSearchProducts()
      } else {
        this.getShops()
      }
    },
    // 价格排序
    priceSort () {
      this.salesOrder = "";
      if (this.type !== 1) {
        this.type = 1
        this.priceOrder = "asc";
      } else {
        this.type = 2
        this.priceOrder = "desc";
      }
      // this.page = 1
      this.index = '2'
      this.maxMoney = ''
      this.minMoney = ''
      if (this.searchVal === '宝贝') {
        this.getSearchProducts()
      } else {
        this.getShops()
      }
    },
    // 销量排序
    salesSort () {
      this.priceOrder = "";
      if (this.volume !== 1) {
        this.volume = 1
        this.salesOrder = "asc";
      } else {
        this.volume = 2
        this.salesOrder = "desc";
      }
      // this.page = 1
      this.index = '3'
      this.maxMoney = ''
      this.minMoney = ''
      if (this.searchVal === '宝贝') {
        this.getSearchProducts()
      } else {
        this.getShops()
      }
    }
  },
  watch: {
    searchObj: {
      handler (newVal, oldVal) {
        this.searchInfo()
      },
      deep: true
    }
  }
}
</script>
<style lang = 'scss' scoped>
.search {
  margin-top: 20px;
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  padding-bottom: 143px;
  text-align: center;
  .banxin {
    width: 1252px;
    height: 100%;
    margin: 0 auto;
    .head {
      width: 100%;
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .all {
        margin-right: 20px;
      }
      .keyword {
        margin: 0 20px;
        color: #ff7800;
      }
      .arrow {
        background-image: url('../../../static/image/xiangyou@2x.png');
        width: 5px;
        height: 10px;
      }
    }
    .result {
      width: 100%;
      background-color: #ffffff;
      padding: 0 45px 30px;
      box-sizing: border-box;
      margin-bottom: 30px;
      .sort {
        width: 100%;
        height: 63px;
        line-height: 27px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f1f1f1;
        color: #666666;
        .default {
          margin-left: 20px;
          cursor: pointer;
        }
        .sales {
          margin-right: 20px;
          cursor: pointer;
          img{
            width: 9px;
            height: 16px;
            vertical-align: middle;
          }
        }
        .price {
          display: flex;
          margin: 0 20px;
          cursor: pointer;
          .arr {
            vertical-align: middle;
            width: 12px;
            margin-left: 3px;
            .up {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-bottom-color: #999999;
            }
            .down {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-top-color: #999999;
              margin-top: 3px;
            }
          }
        }
        .active{
            color: #FF7800;
            .arr{
              .high{
                border-top-color: #FF7800;
              }
              .low{
                border-bottom-color: #FF7800;
              }
            }
          }
          .priceBox{
            display: flex;
            .min,
            .max {
              display: flex;
              width: 100px;
              height: 28px;
              padding: 0 5px;
              border: 1px solid #ccc;
              box-sizing: border-box;
              input {
                width: 70px;
                flex: 1;
                outline: none;
                border: none;
              }
            }
            .btn {
              width: 50px;
              height: 28px;
              border: 1px solid #ccc;
              box-sizing: border-box;
              cursor: pointer;
              margin: 0 20px;
            }
            .clear {
              cursor: pointer;
              color: #999999;
            }
          }
      }
      .empty,.network{
        width: 100%;
        text-align: center;
        padding: 200px 0;
      }
      .store {
        width: 100%;
        padding-top: 28px;
        box-sizing: border-box;
        .storeBox {
          width: 100%;
          margin-bottom: 50px;
          .top {
            display: flex;
            .storeImg {
              width: 80px;
              height: 80px;
              margin-right: 30px;
            }
            .storeDesc {
              flex: 1;
              text-align: left;
              .storeName {
                font-size: 20px;
                margin-bottom: 10px;
              }
              .storeSite {
                font-size: 14px;
              }
            }
            .enter {
              color: #ff7800;
              cursor: pointer;
            }
          }
          .content {
            display: flex;
            justify-content: space-between;
            margin-left: 110px;
            width: 1048px;
            overflow-y: auto;
            padding: 20px 10px;
            box-sizing: border-box;
            background-color: #f5f5f5;
            border: 1px solid #e5e5e5;
            .productBox {
              cursor: pointer;
              width: 190px;
              padding: 10px 15px;
              margin-right: 20px;
              box-sizing: border-box;
              background-color: #ffffff;
              img {
                width: 160px;
                height: 160px;
              }
              .productName {
                font-size: 12px;
                font-weight: bold;
                margin: 13px 0;
              }
              .price {
                font-size: 16px;
                color: #ff7800;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    .guessYouLike {
      width: 100%;
      padding: 30px 45px;
      background-color: #ffffff;
      box-sizing: border-box;
      .title {
        text-align: left;
        font-size: 26px;
        margin-bottom: 22px;
      }
    }
  }
}
>>>.el-pagination{
  text-align: right;
  .el-pager{
    li:not(.disabled):hover{
      color: #FF7800;
    }
    li:not(.disabled).active{
      background-color: #FF7800;
    }
    li:not(.disabled).active:hover{
      color: #F4F4F5;
    }
  }
}
.recommendPage{
  padding: 0 56px;
  box-sizing: border-box;
  position: relative;
  .swiper-container{
    position: static;
    width: 100%;
    .swiper-slide{
      width: 100%;
      text-align: center;
      img{
        width: 100%;
        height: 229px;
        margin-bottom: 20px;
      }
      .name{
        font-size: 13px;
        font-weight: bold;
      }
      .price{
        margin: 12px 0;
        .presentPrice{
          font-size: 15px;
          color: #FF7800;
          font-weight: bold;
        }
        .originalPrice{
          font-size: 13px;
          color: #666666;
          text-decoration: line-through;
        }
      }
      .line{
        width: 130px;
        height: 2px;
        background-color: #F0F0F0;
        margin: 0 auto;
        margin-bottom: 10px;
      }
      .desc{
        font-size: 13px;
        color: #999999;
      }
    }
  }
}
.mySwiperLbtn{
  width: 32px;
  height: 32px;
  background-image: url('../../../static/image/zuoa@2x.png');
  background-size: cover;
  left: 0;
}
.mySwiperRbtn{
  width: 32px;
  height: 32px;
  background-image: url('../../../static/image/youa@2x.png');
  background-size: cover;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue